export function formatDate(
    input: string | Date | null | undefined,
    pattern: 'D.M.YYYY' | 'D.M.HH:mm' | 'D.M.YYYY HH:mm'
): string {
    if (!input) return ''
    const d = typeof input === 'string' ? new Date(input) : input
    if (isNaN(d.getTime())) return ''
    if (pattern === 'D.M.YYYY') {
        return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`
    }
    const hh = String(d.getHours()).padStart(2, '0')
    const mm = String(d.getMinutes()).padStart(2, '0')
    if (pattern === 'D.M.YYYY HH:mm') {
        return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()} ${hh}:${mm}`
    }
    return `${d.getDate()}. ${d.getMonth() + 1}. ${hh}:${mm}`
}

export function isOnOrAfter(date: string | Date, threshold: Date): boolean {
    const d = typeof date === 'string' ? new Date(date) : date
    return d.getTime() >= threshold.getTime()
}

export function isBefore(date: string | Date, threshold: Date): boolean {
    const d = typeof date === 'string' ? new Date(date) : date
    return d.getTime() < threshold.getTime()
}
